import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import ManagerDashboardActions from 'actions/ManagerDashboardActions';
import ManagerDashboardStore from 'stores/ManagerDashboardStore';
import AdminSuggestedActions from 'components/dashboard/admin/AdminSuggestedActions';
import {shouldUpdate} from 'components/StatsPage2.utils';

const NUM_ACTIONS_SHOWN = 3;
const widgetId = 'exec-suggested-actions';

@connectToStores
export default class AdminSuggestedActionsContainer extends React.PureComponent {
  static getStores() {
    return [ManagerDashboardStore];
  }

  static getPropsFromStores() {
    const store = ManagerDashboardStore.getState();
    const {widgets, widgetState} = store;
    return {widgets, widgetState};
  }

  componentDidMount() {
    this.getWidget();
  }

  componentDidUpdate(prevProps) {
    if (!shouldUpdate(prevProps, this.props, false)) {
      return;
    }
    this.getWidget();
  }

  getWidget() {
    const {startDate, endDate} = this.props;
    const widgetConfig = {
      startDate: startDate,
      endDate: endDate,
      maxResults: NUM_ACTIONS_SHOWN,
      widgetId: widgetId,
      widgetType: 'EXEC_ACTION_RECOMMENDATIONS',
    };

    ManagerDashboardActions.getWidget.defer([widgetConfig, null]);
  }

  render() {
    if (!this.props.widgets) return null;

    const widgetState = this.props.widgetState.get(widgetId);
    const widget = this.props.widgets.get(widgetId);

    if (!widget) return null;

    return (
      <AdminSuggestedActions
        key={widget.widgetId}
        widgetState={widgetState}
        numActionsShown={NUM_ACTIONS_SHOWN}
        fromPath={this.props.fromPath}
        {...widget}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        location={this.props.location}
      />
    );
  }
}
